import { useEffect, useState } from "react";

// @mui
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
// auth
import { useAuthContext } from "../../../../auth/useAuthContext";

import { Link as RouterLink } from "react-router-dom";
import useCopyToClipboard from "../../../../hooks/useCopyToClipboard";
import { getOs } from "../../../../utils/getOs";
import { useLocales } from "../../../../locales";
import { PATH_DASHBOARD } from "../../../../routes/paths";
import { CHECKOUT_URL } from "../../../../config";
import Iconify from "../../../../components/iconify";
import { fDate } from "../../../../utils/formatTime";

// ----------------------------------------------------------------------

export default function AccountGeneral() {
  const { translate } = useLocales();
  const { user } = useAuthContext();
  const {
    isFreeAccount,
    recurringSubscription,
    email,
    darkWebMonitoringEnabled,
    status,
  } = user;

  const handleRenewClick = () => {
    window.open(CHECKOUT_URL + `?email=${encodeURI(email)}`, "_blank");
  };

  const [open, setOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("Windows");
  const DONotAllowed = Boolean(!isFreeAccount && !status);

  console.log(Boolean(!isFreeAccount && !status));
  useEffect(() => {
    setCurrentTab(getOs());
  }, []);
  const { copy } = useCopyToClipboard();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Card sx={{ p: 3 }}>
          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
            }}
          >
            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {translate("username")}:
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {email}
              </Typography>
            </>
            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {translate("password")}:
              </Typography>
              <Stack spacing={2} direction="row" justifyContent="space-between">
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  ********
                </Typography>

                <Link
                  to={PATH_DASHBOARD.user.changePassword}
                  component={RouterLink}
                  underline="hover"
                  sx={{
                    fontSize: "0.85em",
                    "&:hover": {
                      color: "#c55c01",
                    },
                  }}
                >
                  {translate(`changePassword`)}
                </Link>
              </Stack>
            </>
            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {translate("accountPage.accountStatus")}:
              </Typography>
              {user?.status ? (
                <Typography variant="subtitle2" sx={{ color: "#00AB55" }}>
                  {translate("active")}
                </Typography>
              ) : (
                <Typography variant="subtitle2" sx={{ color: "#FF3030" }}>
                  {translate("inactive")}
                  <Button
                    onClick={() => handleRenewClick()}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ ml: 1 }}
                  >
                    {translate(`accountPage.renewAccount`)}
                  </Button>
                </Typography>
              )}
            </>
            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {translate("accountPage.accountType")}:
              </Typography>

              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {user?.planName}
              </Typography>
            </>
            {/*<>*/}
            {/*    <Typography variant="subtitle2" sx={{mb: 0.5}}>*/}
            {/*        /!*{translate('accountPage.recurringSubscription')}:*!/*/}
            {/*    </Typography>*/}
            {/*    <Stack spacing={2} direction="row" justifyContent="space-between">*/}

            {/*        {user?.recurringSubscription ? <Typography variant="subtitle2" sx={{color: '#00AB55'}}>*/}
            {/*            {translate('active')}*/}
            {/*        </Typography> : <Typography variant="subtitle2" sx={{color: '#FF3030'}}>*/}
            {/*            {translate('inactive')}*/}
            {/*        </Typography>}*/}

            {/*      */}

            {/*    </Stack>*/}

            {/*</>*/}
            <>
              {isFreeAccount || !recurringSubscription ? (
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  {translate("accountPage.endDate")}:
                </Typography>
              ) : (
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  {translate("accountPage.nextBillingDate")}:
                </Typography>
              )}
              <Stack spacing={2} direction="row" justifyContent="space-between">
                <Stack direction="row">
                  {recurringSubscription && !isFreeAccount ? (
                    <Tooltip
                      title={translate("accountPage.nextBillingDateWarning")}
                    >
                      <span>
                        <Iconify
                          icon="si:shield-tip-line"
                          width="24"
                          height="24"
                          sx={{ color: "#FD8017", mr: 0.5 }}
                        />
                      </span>
                    </Tooltip>
                  ) : null}

                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {fDate(user?.dateClose, "MMMM d yyyy")}
                  </Typography>
                </Stack>

                {isFreeAccount || !recurringSubscription ? (
                  <Link
                    to=""
                    onClick={() => handleRenewClick()}
                    component={RouterLink}
                    underline="hover"
                    sx={{
                      fontSize: "0.85em",
                      "&:hover": {
                        color: "#c55c01",
                      },
                    }}
                  >
                    {translate(`accountPage.getSubscription`)}
                  </Link>
                ) : (
                  <Link
                    to={PATH_DASHBOARD.user.cancelSubscription}
                    component={RouterLink}
                    underline="hover"
                    sx={{
                      fontSize: "0.85em",
                      "&:hover": {
                        color: "#c55c01",
                      },
                    }}
                  >
                    {translate(`accountPage.cancelSubscription`)}
                  </Link>
                )}
              </Stack>
            </>
            {/*<>*/}
            {/*    <Typography variant="subtitle2" sx={{mb: 0.5}}>*/}
            {/*        {translate('accountPage.endDate')}:*/}
            {/*    </Typography>*/}
            {/*    <Typography variant="body2" sx={{color: 'text.secondary'}}>*/}
            {/*        */}
            {/*    </Typography>*/}
            {/*</>*/}
            {/*<>*/}
            {/*    <Typography variant="subtitle2" sx={{mb: 0.5}}>*/}
            {/*        {translate(`accountPage.subRemaining`)}*/}
            {/*    </Typography>*/}
            {/*    <Typography variant="body2" sx={{color: 'text.secondary'}}>*/}
            {/*        {translate(`accountPage.autoRenew`)} {user?.recurringSubscription ? translate(`on`) : translate(`off`)}*/}
            {/*    </Typography>*/}
            {/*</>*/}

            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {translate(`accountPage.activationCode`)}:
              </Typography>
              <Stack spacing={2} direction="row" justifyContent="space-between">
                <Typography
                  variant="subtitle2"
                  sx={{ color: "text.secondary" }}
                >
                  {user?.vpnAuthCode}
                </Typography>

                <Link
                  to={`/user/setup-vpn?token=${user?.setupVpnToken}id=${user.id}`}
                  target="_blank"
                  rel="noopener"
                  component={RouterLink}
                  underline="hover"
                  sx={{
                    fontSize: "0.85em",
                    "&:hover": {
                      color: "#c55c01",
                    },
                  }}
                >
                  {translate(`setup`)}
                </Link>

                {/*<Stack textAlign="center" justifyContent="center">*/}
                {/*    <IconButton onClick={()=>copy(user?.vpnAuthCode)} component={RouterLink}>*/}
                {/*        <Iconify icon="ic:sharp-file-copy" />*/}
                {/*    </IconButton>*/}
                {/*</Stack>*/}
              </Stack>
            </>

            <>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                <Tooltip title={translate("DataOwlTip")}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Iconify
                      icon="si:shield-tip-line"
                      width="24"
                      height="24"
                      sx={{ color: "#FD8017", mr: 0.5 }}
                    />
                    {translate("DataOwl")}
                  </span>
                </Tooltip>
              </Typography>
              <Stack spacing={2} direction="row" justifyContent="space-between">
                {darkWebMonitoringEnabled ? (
                  <Typography variant="subtitle2" sx={{ color: "#00AB55" }}>
                    {translate("active")}
                  </Typography>
                ) : (
                  <Typography variant="subtitle2" sx={{ color: "#FF3030" }}>
                    {translate("inactive")}
                  </Typography>
                )}
                {DONotAllowed ? (
                  <Link
                    to=""
                    onClick={() => handleRenewClick()}
                    component={RouterLink}
                    underline="hover"
                    sx={{
                      fontSize: "0.85em",
                      "&:hover": {
                        color: "#c55c01",
                      },
                    }}
                  >
                    {translate(`accountPage.getSubscription`)}
                  </Link>
                ) : (
                  <Link
                    to={PATH_DASHBOARD.user.settings}
                    component={RouterLink}
                    underline="hover"
                    sx={{
                      fontSize: "0.85em",
                      "&:hover": {
                        color: "#c55c01",
                      },
                    }}
                  >
                    {translate(`accountPage.setupMonitoring`)}
                  </Link>
                )}
              </Stack>
            </>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}
